/** @jsx jsx */
import { SingleSelect } from "@eworkit/iris";
import { FC, useCallback } from "react";
import { jsx } from "theme-ui";

import { RelatedEntities } from "@/data/related";

import { useRelatedEntitiesNav } from "./RelatedEntitiesNavContext";
import { useRelatedEntitiesTabsData } from "./useRelatedEntitiesTabsData";

interface RelatedEntitiesTabSelectProps {
  relatedEntities: RelatedEntities;
}

export const RelatedEntitiesTabSelect: FC<RelatedEntitiesTabSelectProps> = ({ relatedEntities }) => {
  const { keys, activeTab, setActiveTab } = useRelatedEntitiesNav();
  const tabsData = useRelatedEntitiesTabsData(relatedEntities);

  const options = keys.map(k => ({
    label: `${tabsData[k].label} (${tabsData[k].count ?? 0})`,
    value: k,
  }));

  const handleChange = useCallback(
    (newValue?: any) => {
      setActiveTab(newValue.value);
    },
    [setActiveTab],
  );

  return (
    <SingleSelect
      size="md"
      options={options}
      value={options.find(o => o.value === activeTab)}
      onChange={handleChange}
      clearable={false}
    />
  );
};
